import { render, staticRenderFns } from "./StudySets.vue?vue&type=template&id=178cc010&scoped=true&"
import script from "./StudySets.vue?vue&type=script&lang=js&"
export * from "./StudySets.vue?vue&type=script&lang=js&"
import style0 from "./StudySets.vue?vue&type=style&index=0&id=178cc010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178cc010",
  null
  
)

export default component.exports